import { Skeleton } from '@openeducation/oe-it-components';
import { useDataTable } from '@openeducation/oe-it-hooks';
import { convertToUtc } from '@openeducation/oe-it-utils';
import React, { useState } from 'react';
import { DataTable } from 'react-native-paper';

import { ActiveClassCardTableHeader } from './active-class-card-table-header';
import { ActiveClassCardTableItem } from './active-class-card-table-item';
import { useOpenLink } from '../../hooks/use-open-link';
import { useWorkSchedule } from '../../hooks/use-work-schedule';
import { ActiveClass } from '../../interfaces/active-class';
import {
  ClassStudentsModal,
  StudentListItem,
} from '../class-students-modal/class-students-modal';

interface ActiveClassDataTableProps {
  activeClasses?: ActiveClass[];
  totalStudent: number;
  isLoading: boolean;
  onReassignTeacher: ({
    originalTeacherId,
    classroomId,
  }: {
    originalTeacherId: number;
    classroomId: number;
  }) => void;
}
export const ActiveClassDataTable = ({
  activeClasses,
  totalStudent,
  isLoading,
  onReassignTeacher,
}: ActiveClassDataTableProps) => {
  const [students, setStudents] = useState<StudentListItem[]>([]);

  const showStudentList = (list: StudentListItem[]) => {
    setStudents(list);
  };
  const { openLink } = useOpenLink();
  const {
    //Pagination
    page,
    numberOfPages,
    itemsPerPage,
    itemsPerPageList,
    onItemsPerPageChange,
    onPageChange,
    from,
    to,
    list: data,
    //Sort
    onSortChange,
    sortField,
    sortDirection,
    //Filter
    onFilterChange,
  } = useDataTable<ActiveClass>(activeClasses, {
    defaultField: 'teacherPresent',
    defaultDirection: 'asc',
  });
  const { isScheduledToWorkNow, isScheduledToWorkAtTime } = useWorkSchedule();

  const checkIfTeachClassLinkEnabled = (
    classBegin?: Date,
    classEnd?: Date
  ): boolean => {
    if (!classEnd || !classBegin) {
      return false;
    }

    const classEndTime = convertToUtc(classEnd);
    return Boolean(
      isScheduledToWorkNow() && isScheduledToWorkAtTime(classEndTime)
    );
  };
  const onEnterMonitorPress = (classObject: ActiveClass) => {
    openLink({
      link: classObject.link + '&teacherId=' + classObject.teacherId,
      newTab: true,
    });
  };

  const onTeachPress = (
    classroomId: number,
    originalTeacherId: number,
    url: string
  ) => {
    openLink({
      link: url,
      newTab: true,
    });
    onReassignTeacher({ originalTeacherId, classroomId });
  };
  return (
    <DataTable>
      <ActiveClassCardTableHeader
        onSortChange={onSortChange}
        onFilterChange={onFilterChange}
        sortField={sortField}
        sortDirection={sortDirection}
        totalStudent={totalStudent}
      />
      {isLoading ? (
        <>
          {[1, 2].map((key) => (
            <DataTable.Row key={key}>
              <DataTable.Cell>
                <Skeleton />
              </DataTable.Cell>
            </DataTable.Row>
          ))}
        </>
      ) : (
        <>
          {(data as ActiveClass[])?.map((item) => (
            <ActiveClassCardTableItem
              key={item.id}
              onEnterMonitorPress={() => onEnterMonitorPress(item)}
              onTeachPress={() =>
                onTeachPress(item.id, Number(item.teacherId), item.link)
              }
              checkIfTeachClassLinkEnabled={checkIfTeachClassLinkEnabled}
              onSeeStudentListPress={showStudentList}
              {...item}
            />
          ))}
        </>
      )}
      <DataTable.Pagination
        page={page}
        numberOfPages={numberOfPages}
        onPageChange={onPageChange}
        label={`${from + 1}-${to} of ${data?.length}`}
        numberOfItemsPerPageList={itemsPerPageList}
        numberOfItemsPerPage={itemsPerPage}
        onItemsPerPageChange={onItemsPerPageChange}
        showFastPaginationControls
        selectPageDropdownLabel="Rows per page"
      />
      <ClassStudentsModal onClose={() => setStudents([])} students={students} />
    </DataTable>
  );
};
